import {
  useMutation,
  useQueryClient,
type 
  QueryClient} from '@tanstack/react-query';

import { getSandboxesQueryOptions } from '@/api/getSandboxes';
import { api } from '@/lib/api-client';
import type { MutationConfig } from '@/lib/react-query';

import type { CreateSandbox } from '../models/createSandbox';

export const createSandbox = (sandbox: CreateSandbox) => {
  return api.post('/v1/sandboxes', sandbox);
};

interface useCreateSandboxOptions {
  gameCode: string;
  mutationConfig?: MutationConfig<typeof createSandbox>;
  queryClient?: QueryClient;
}

export const useCreateSandbox = ({
  gameCode,
  mutationConfig,
  queryClient,
}: useCreateSandboxOptions) => {
  const _queryClient = queryClient ?? useQueryClient();
  const { onSuccess, ...restConfig } = mutationConfig ?? {};
  
  return useMutation({
    onSuccess: (...args) => {
      void _queryClient.invalidateQueries({
        queryKey: getSandboxesQueryOptions({ game_code: gameCode }).queryKey,
      });
      onSuccess?.(...args);
    },
    mutationFn: createSandbox,
    ...restConfig,
  });
};
